const AuthStates = {
    AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
    AUTH_LOGIN_FAILURE: 'AUTH_LOGIN_FAILURE',
    AUTH_LOGOUT_SUCCESS: 'AUTH_LOGOUT_SUCCESS',
    AUTH_LOGOUT_FAILURE: 'AUTH_LOGOUT_FAILURE',
    AUTH_AUTHENTICATION_SUCCESS: 'AUTH_AUTHENTICATION_SUCCESS', // пользователь найден, требуется 2auth для дальнейшей авторизации
    AUTH_CURRENT_CONTRACT_SUCCESS: 'AUTH_CURRENT_CONTRACT_SUCCESS'
};

const AuthActions = {
    AUTH_LOGIN: 'AUTH_LOGIN',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    AUTH_UPDATE_USER: 'AUTH_UPDATE_USER',
    AUTH_AUTHENTICATE: 'AUTH_AUTHENTICATE',  // храним пользователя, полученного на первом шаге 2auth, но еще не авторизованного
    AUTH_CHANGE_CURRENT_CONTRACT: 'AUTH_CHANGE_CURRENT_CONTRACT'
};

export default {
    AuthStates,
    AuthActions
};